export const authoringCourseContextTypes = Object.freeze({
  PRIVATE_BRANCH: 'privateBranchContext',
  PUBLIC_BRANCH: 'publicBranchContext',
  SESSION_GROUP: 'sessionGroupContext',
  SESSION_GROUP_CREATION_JOB: 'sessionGroupCreationJobContext',
} as const);

export default authoringCourseContextTypes;
